webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	data: function data() {
		return {
			blocked: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			// true for mobile device
			this.checkLock();
			window.addEventListener('orientationchange', function () {
				_this.checkLock();
			});
		} else {}
	},
	methods: {
		checkLock: function checkLock() {
			var _this2 = this;

			setTimeout(function () {
				console.log('check', window.innerHeight, window.innerWidth, window.innerHeight > window.innerWidth);
				if (window.innerHeight > window.innerWidth) _this2.blocked = false;else _this2.blocked = false;
			}, 100);
		}
	}
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {},
  data: function data() {
    return {
      prompt: null,
      skip_resume_app: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('beforeinstallprompt', function (e) {
      console.log('before prompt fired');

      _this.prompt = e;

      e.preventDefault();
    });

    var saved_data = window.localStorage.getItem("target");

    if (saved_data && !this.skip_resume_app) return this.$router.push({ name: "Geolocation", params: { place: saved_data } });
  },
  methods: {
    install: function install() {
      var prompt = this.prompt;
      this.prompt = null;
      console.log('install !');

      prompt.prompt();
      prompt.userChoice.then(function (result) {
        console.log('install prompt succeed !');
      });
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {},
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_geolocation_place1_jpg__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_geolocation_place1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_geolocation_place1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_geolocation_place2_jpg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_geolocation_place2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_geolocation_place2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_geolocation_place3_jpg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_geolocation_place3_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_geolocation_place3_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_geolocation_place4_jpg__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_geolocation_place4_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_geolocation_place4_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_geolocation_place5_jpg__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_geolocation_place5_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_geolocation_place5_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geolocation',
  components: {},
  props: {
    place: String
  },
  data: function data() {
    return {
      target: null
    };
  },
  mounted: function mounted() {
    var target = this.place || "place1";

    if (this.authorized_target.indexOf(target) == -1) {
      throw new Error('Target ' + target + ' not available');
    }

    this.target = target;
    window.localStorage.setItem('target', target);
  },
  methods: {},
  computed: {
    authorized_target: function authorized_target() {
      return ["place1", "place2", "place3", "place4", "place5"];
    },
    borne_number: function borne_number() {
      return this.authorized_target.indexOf(this.target) + 1;
    },
    geolocation_img: function geolocation_img() {
      var imgs = {
        place1: __WEBPACK_IMPORTED_MODULE_0__assets_geolocation_place1_jpg___default.a,
        place2: __WEBPACK_IMPORTED_MODULE_1__assets_geolocation_place2_jpg___default.a,
        place3: __WEBPACK_IMPORTED_MODULE_2__assets_geolocation_place3_jpg___default.a,
        place4: __WEBPACK_IMPORTED_MODULE_3__assets_geolocation_place4_jpg___default.a,
        place5: __WEBPACK_IMPORTED_MODULE_4__assets_geolocation_place5_jpg___default.a
      };

      return imgs[this.target];
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_qrcode_reader__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_qrcode_reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_qrcode_reader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'QrCode',
  components: { QrcodeStream: __WEBPACK_IMPORTED_MODULE_0_vue_qrcode_reader__["QrcodeStream"] },
  data: function data() {
    return {
      target: null
    };
  },

  methods: {
    onDecode: function onDecode(decoded) {

      var qrcode_to = {
        "test1": "place1",
        "test2": "place2",
        "test3": "place3",
        "test4": "place4"
        // [qrcode]: [page target]

      };console.log('Qrcode : ', decoded);
      if (!decoded || !qrcode_to[decoded]) {
        this.target = null;
        return;
      }

      // Dès qu'il y a un scan valide, on enregistre la target, et on change de page dès l'appuie sur le bouton
      this.target = qrcode_to[decoded];
    },
    autovalidate: function autovalidate() {
      var target = window.localStorage.getItem('target');
      this.target = target;
    },
    next: function next() {
      this.$router.push(this.target);
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BorneHeader__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_links_js__ = __webpack_require__(71);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: { BorneHeader: __WEBPACK_IMPORTED_MODULE_1__components_BorneHeader__["a" /* default */] },
  data: function data() {
    return {
      target: null
    };
  },
  mounted: function mounted() {
    this.target = window.localStorage.getItem('target');
  },
  computed: {
    videos: function videos() {
      return __WEBPACK_IMPORTED_MODULE_2__components_links_js__["a" /* default */][this.target];
    },
    borne_number: function borne_number() {
      return this.target ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.target.slice(5)) : '';
    },
    next_place: function next_place() {
      return 'place' + (this.borne_number + 1);
    },
    is_final_place: function is_final_place() {
      return !__WEBPACK_IMPORTED_MODULE_2__components_links_js__["a" /* default */][this.next_place];
    }
  }
});

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BorneHeader_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41774744_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BorneHeader_vue__ = __webpack_require__(70);
function injectStyle (ssrContext) {
  __webpack_require__(69)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BorneHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41774744_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BorneHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {},
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BorneHeader__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: { BorneHeader: __WEBPACK_IMPORTED_MODULE_0__components_BorneHeader__["a" /* default */] },
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video',
  components: {},
  props: {
    video: String
  },
  methods: {}
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {},
  data: function data() {
    return {};
  },
  methods: {
    resetGeolocationPlace: function resetGeolocationPlace() {
      console.log('Location deleted');
      window.localStorage.removeItem("target");
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(29);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_131bd3b1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(28);
function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_131bd3b1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.blocked),expression:"blocked"}],attrs:{"id":"landscape_blocker"}},[_vm._v("Merci de tourner votre écran !")]),_vm._v(" "),_c('main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Tutorial__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Geolocation__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_QRCode__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Place__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_LastPanel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Video__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Debug__ = __webpack_require__(83);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [
  // {
  //   path: '/',
  //   name: 'Hello',
  //   component: Hello
  // },
  {
    path: '/debug',
    name: "Debug",
    component: __WEBPACK_IMPORTED_MODULE_9__views_Debug__["a" /* default */]
  }, {
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home__["a" /* default */]
  }, {
    path: '/tutorial',
    name: 'Tutorial',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Tutorial__["a" /* default */]
  }, {
    path: '/geolocation/:place?',
    name: 'Geolocation',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Geolocation__["a" /* default */],
    props: true
  }, {
    path: '/video/:video',
    name: "Video",
    component: __WEBPACK_IMPORTED_MODULE_8__views_Video__["a" /* default */],
    props: true
  }, {
    path: '/qrcode',
    name: 'QRCode',
    component: __WEBPACK_IMPORTED_MODULE_5__views_QRCode__["a" /* default */]
  }, {
    path: '/place',
    alias: ['/place1', '/place2', '/place3', '/place4', '/place5'],
    name: 'Place',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Place__["a" /* default */]
  }, {
    path: '/lastpanel',
    name: 'LastPanel',
    component: __WEBPACK_IMPORTED_MODULE_7__views_LastPanel__["a" /* default */]
  }]
}));

/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb04e34c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(33);
function injectStyle (ssrContext) {
  __webpack_require__(32)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb04e34c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page home"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"welcome"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"cta"},[_c('router-link',{staticClass:"buttonLink",attrs:{"to":"/Tutorial"}},[_vm._v("Commencez")]),_vm._v(" "),(_vm.prompt)?_c('p',{staticClass:"buttonLink",on:{"click":_vm.install}},[_vm._v("Installer l'app")]):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('img',{attrs:{"src":__webpack_require__(34)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("Le Bois"),_c('br'),_vm._v("de Riquet")]),_vm._v(" "),_c('h5',{staticClass:"formation"},[_vm._v("Découvrez l'histoire de la formation"),_c('br'),_vm._v(" géologique du Bois de Riquet")]),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-cahm-definitif-sans-baseline.70a2a8a.png";

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tutorial_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a972ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tutorial_vue__ = __webpack_require__(37);
function injectStyle (ssrContext) {
  __webpack_require__(36)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tutorial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a972ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tutorial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page tutorial"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"cta"},[_c('router-link',{staticClass:"buttonLink",attrs:{"to":"/geolocation"}},[_vm._v("Allez à la carte")])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('img',{attrs:{"src":__webpack_require__(38)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tuto"},[_c('h1',[_vm._v("Comment visiter ?")]),_vm._v(" "),_c('p',[_vm._v("\n        Flashez les QR Codes sur les"),_c('br'),_vm._v("\n        bornes le long du parcours:"),_c('br'),_vm._v("\n        Du contenu interactif vous est"),_c('br'),_vm._v(" \n        alors proposé."),_c('br'),_vm._v("\n        Découvrez ainsi pas à pas"),_c('br'),_vm._v(" \n        toute l'histoire du Bois de"),_c('br'),_vm._v(" \n        Riquet.\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Qr-Code.150736a.jpg";

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geolocation_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_503e4f71_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geolocation_vue__ = __webpack_require__(46);
function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geolocation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_503e4f71_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geolocation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geolocation_place1.e0d6d6b.jpg";

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geolocation_place2.edf3c86.jpg";

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geolocation_place3.bb3bce0.jpg";

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geolocation_place4.8c61b89.jpg";

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geolocation_place5.8a32a39.jpg";

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page view_geolocation"},[_c('div',{staticClass:"geolocation_img"},[_c('img',{attrs:{"src":_vm.geolocation_img,"alt":"L'agglo Herault Mediterrannee"}})]),_vm._v(" "),_c('div',{staticClass:"buttonWrapper"},[_c('router-link',{staticClass:"buttonLink",attrs:{"to":"/Place"}},[_vm._v("Vous êtes à la borne "+_vm._s(_vm.borne_number))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRCode_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2686983e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRCode_vue__ = __webpack_require__(50);
function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2686983e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page view_qrcode"},[_c('div',{staticClass:"qrcode_container"},[_c('qrcode-stream',{staticClass:"qrcode_stream",on:{"decode":_vm.onDecode}}),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',[_c('button',{staticClass:"buttonLink",attrs:{"disabled":!_vm.target},on:{"click":_vm.next}},[_vm._v("Flashez le QR Code")])]),_vm._v(" "),_c('button',{staticStyle:{"position":"absolute","bottom":"5px","right":"5px"},on:{"click":_vm.autovalidate}},[_vm._v("Auto Validate QRCODE")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border_container"},[_c('div',{staticClass:"border top left"}),_vm._v(" "),_c('div',{staticClass:"border top right"}),_vm._v(" "),_c('div',{staticClass:"border bottom left"}),_vm._v(" "),_c('div',{staticClass:"border bottom right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Place_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77722abe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Place_vue__ = __webpack_require__(72);
function injectStyle (ssrContext) {
  __webpack_require__(52)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Place_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77722abe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Place_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"borneheader"},[_c('h1',{staticClass:"boisRiquet"},[_c('div',{staticClass:"texte_titre"},[_vm._v("Le Bois ")]),_vm._v(" "),_c('div',{staticClass:"texte_titre2"},[_vm._v("de Riquet")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
	place1: [{ name: "L'éruption de l'Arnet", link: "/#/video/film-BDR-01s" }, { name: "La coulée refroidie", link: "/bdr/static/360/var_1/360.html" }],
	place2: [{ name: "La coulée se creuse", link: "/bdr/static/360/var_3/360.html" }],
	place3: [{ name: "Tableau des espèces", link: "/#/video/film-tableau-especes-V5" }],
	place4: [{ name: "Les hyènes contre les hommes", link: "https://d19gm1nt00vbau.cloudfront.net/" }, { name: "La procession", link: "/bdr/static/360/var_4/360.html" }],
	place5: [{ name: "La coulée de boue", link: "/bdr/static/360/var_5/360.html" }, { name: "L'ouverture du coffre-fort", link: "/bdr/static/360/var_6/360.html" }]

});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page place1"},[_c('borne-header'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v("Borne N°"+_vm._s(_vm.borne_number))]),_vm._v(" "),_c('div',{staticClass:"youtubeList"},_vm._l((_vm.videos),function(video){return _c('a',{key:video.name,staticClass:"buttonLink youtubeLink",attrs:{"href":video.link}},[_vm._v(_vm._s(video.name))])}),0),_vm._v(" "),(_vm.is_final_place)?_c('router-link',{staticClass:"buttonLink buttonLink2",attrs:{"to":"/LastPanel"}},[_vm._v("Fin")]):_c('router-link',{staticClass:"buttonLink buttonLink2",attrs:{"to":{name: 'Geolocation', params: {place: _vm.next_place}}}},[_vm._v("Allez à la borne "+_vm._s(_vm.borne_number + 1))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastPanel_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_818e5104_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastPanel_vue__ = __webpack_require__(75);
function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_818e5104_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page final"},[_vm._m(0),_vm._v(" "),_c('borne-header'),_vm._v(" "),_c('p',[_vm._v("Un projet réalisé en collaboration avec")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("Un projet financé par ")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"cta"},[_c('router-link',{staticClass:"buttonLink",attrs:{"to":"/"}},[_vm._v("Quitter")])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("Merci pour "),_c('br'),_vm._v(" votre visite !")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"images"},[_c('img',{attrs:{"src":__webpack_require__(76),"alt":"Inrap: Institut national de recherches archéologiques préventives"}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(77),"alt":"GREPAM"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"images"},[_c('img',{attrs:{"src":__webpack_require__(78),"alt":"L'agglo Herault Mediterrannee"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"images"},[_c('img',{attrs:{"src":__webpack_require__(79),"alt":"Europe"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_inrap.157ae99.jpg";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_grepam.afbf786.jpg";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo3.91b657b.png";

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_eu.fd5d00b.jpg";

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Video_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4dd990_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Video_vue__ = __webpack_require__(82);
function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Video_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b4dd990_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page view_video"},[_c('video',{attrs:{"controls":"","autoplay":""}},[_c('source',{attrs:{"type":"video/webm","src":("/static/" + _vm.video + ".webm")}}),_vm._v(" "),_c('source',{attrs:{"type":"video/mp4","src":("/static/" + _vm.video + ".mp4")}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Debug_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d732bf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Debug_vue__ = __webpack_require__(85);
function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50d732bf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Debug_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d732bf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Debug_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page view_debug"},[_c('div',{staticClass:"zone routes"},[_c('p',[_vm._v("Debug Page")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1),_c('br'),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/tutorial"}},[_vm._v("Tutorial")])],1),_c('br'),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/BorneHeader"}},[_vm._v("BorneHeader")])],1),_c('br'),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/geolocation"}},[_vm._v("Geolocation")])],1),_c('br'),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'Geolocation', params: {place: 'place2'}}}},[_vm._v("Geolocation place 2")])],1),_c('br'),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'Geolocation', params: {place: 'place3'}}}},[_vm._v("Geolocation place 3")])],1),_c('br'),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'Geolocation', params: {place: 'place4'}}}},[_vm._v("Geolocation place 4")])],1),_c('br'),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/qrcode"}},[_vm._v("QRCode")])],1),_c('br'),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/place"}},[_vm._v("Place")])],1),_c('br'),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/lastpanel"}},[_vm._v("LastPanel")])],1),_c('br'),_vm._v(" "),_vm._m(0),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"zone actions"},[_c('p',[_vm._v("Debug actions")]),_vm._v(" "),_c('ul',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.resetGeolocationPlace}},[_vm._v("Reset du parcours")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"/static/360.html"}},[_vm._v("Vue 360")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[21]);


// WEBPACK FOOTER //
// static/js/app.d8b8f5504136cad1670f.js